import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { provideConsentBannerConfig } from './consent-banner/provider';
import { ConsentBannerService } from './consent-banner/consent-banner.service';

export function provideAnalytics(enabled?: boolean, config?: Partial<CookieConsent.CookieConsentConfig>): EnvironmentProviders[] {
  if (enabled) {
    return [
      provideConsentBannerConfig(enabled, config),
      provideEnvironmentInitializer(() => {
        const consentBannerService = inject(ConsentBannerService);
        return consentBannerService.init();
      }),
    ];
  }

  return [];
}
